import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginTop: 20,
    alignSelf: "center",
  },
  contentCard: {
    width: 300,
    height: 250,
    borderRadius: 8,
    marginTop: 20,
    paddingHorizontal: 20,
    paddingVertical: 40,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  textDescription: {
    fontWeight: "normal",
    fontSize: 14,
    fontWeight: "500",
    lineHeight: 25,
    marginBottom: 12,
  },
  contentEdit: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  imgBank: {
    width: 30,
    height: 19,
    position: "absolute",
    right: 10,
    bottom: 10,
  },
  btnAdd: {
    padding: 10,
    width: 320,
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    position: "relative",
  },
  textBtn: {
    fontSize: 18,
    textTransform: "uppercase",
    textAlign: "center",
    color: "#FFF",
  },
  img_coin: {
    position: "absolute",
    left: 0,
    top: 25,
    width: 50,
    height: 108,
  },
  textNotFoundAccounts: {
    textAlign: "center",
    marginTop: 10,
    marginBottom: 10,
    fontWeight: "bold",
  },
  selectedCard: {
    color: "#fff",
    textAlign: "center",
    fontSize: 12,
  },

  lbl: {
    fontWeight: "bold",
  },
});

export default styles;
